import React, { useState } from "react";
import { useTranslation } from 'react-i18next';
import { Container, Row, Col, Card, Form, Button, Alert } from 'react-bootstrap';
import BJLogo from '../../../Assets/Images/BJ.png';
import '../../Membership/Membership.css';
import { AuthService } from "../../../Services/Axios/Api";

const ForgotPassword = () => {
    const { t } = useTranslation();
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setError('');
        setSuccess('');
        if (!email) {
            setError(t('ForgotPassword.Validation.EmailRequired'));
            return;
        }
        if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email)) {
            setError(t('ForgotPassword.Validation.EmailInvalid'));
            return;
        }
        setIsLoading(true);
        try {
            const response = await AuthService.ForgotPassword(email);
            if (response.isSuccess) {
                setSuccess(t('ForgotPassword.Success'));
            } else {
                setError(response.errorMessage);
            }
        } catch (error) {
            setError(error.response?.data?.errorMessages?.[0] || t('ForgotPassword.Error'));
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Container className=" d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
            <Row className=" justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
                <Col md={12} lg={12}>
                    <Card className="membership-card pt-4 pb-4">
                        <Card.Body>
                            <div className="text-center mb-4">
                                <h2 className="membership-title">{t('ForgotPassword.Title')}</h2>
                                <p className="membership-subtitle">{t('ForgotPassword.Subtitle')}</p>
                            </div>
                            {error && <Alert variant="danger">{error}</Alert>}
                            {success && <Alert variant="success">{success}</Alert>}
                            <Form onSubmit={handleSubmit}>
                                <Form.Group className="mb-3">
                                    <Form.Label>{t('ForgotPassword.EmailLabel')}</Form.Label>
                                    <Form.Control
                                        type="email"
                                        placeholder={t('ForgotPassword.EmailPlaceholder')}
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        isInvalid={!!error && !success}
                                    />
                                </Form.Group>
                                <Button type="submit" className="w-100 submit-button" disabled={isLoading}>
                                    {isLoading ? (
                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                                    ) : null}
                                    {t('ForgotPassword.SendButton')}
                                </Button>
                            </Form>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default ForgotPassword; 